import React from "react";
import { AnimatePresence } from "framer-motion";

import { IToast } from "shared/components/Toast/types";
import { Toast } from "shared/components/Toast/components";
import { Spacer } from "shared/layout";
import { ToastListContainer } from "./styles";

interface ToastListProps {
  toastList: IToast[];
}

export const ToastList: React.FC<ToastListProps> = ({ toastList }) => (
  <AnimatePresence>
    {!!toastList.length && (
      <ToastListContainer>
        <Spacer size="xs">
          {toastList.map((toast, index) => (
            <Toast key={index} {...toast} />
          ))}
        </Spacer>
      </ToastListContainer>
    )}
  </AnimatePresence>
);
